import * as Immutable from 'immutable';
import {
  GET_DASHBOARD_REQUESTED,
  GET_DASHBOARD_COMPLETED,
  GET_DASHBOARD_FAILED,
  RESET_DASHBOARD_REQUESTED,
  RESET_DASHBOARD_COMPLETED,
  GET_DASHBOARD_ACTIONS_REQUESTED,
  GET_DASHBOARD_ACTIONS_COMPLETED,
  GET_DASHBOARD_ACTIONS_FAILED,
} from '../../actions/dashboard/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: {},
  data: {},
  actionstatus: true,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_ACTIONS_REQUESTED:
      return state.set('error', {}).set('gettingdata', true);

    case GET_DASHBOARD_ACTIONS_COMPLETED:
      return state
        .set('error', {})
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('actionstatus', action.payload);

    case GET_DASHBOARD_ACTIONS_FAILED:
      return state.set('error', action.payload);

    case GET_DASHBOARD_REQUESTED:
      return state.set('error', {}).set('gettingdata', true);

    case GET_DASHBOARD_COMPLETED:
      return state
        .set('error', {})
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_DASHBOARD_FAILED:
      return state.set('error', action.payload);

    case RESET_DASHBOARD_REQUESTED:
      return state
        .set('error', {})
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_DASHBOARD_COMPLETED:
      return state
        .set('error', {})
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('data', {})
        .set('gotdata', true);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
